import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'
import HireColumns from '@/components/GraphqlDataTable/columns/Hire'
import JobColumns from '@/components/GraphqlDataTable/columns/Job'
import CompanyColumns from '@/components/GraphqlDataTable/columns/Company'
import JobShareColumns from '@/components/GraphqlDataTable/columns/JobShare'
import BidColumns from '@/components/GraphqlDataTable/columns/Bid'
import PartnerEmploymentColumns from '@/components/GraphqlDataTable/columns/Employment/Partner'
import PartnerPaymentRequestColumns from '@/components/GraphqlDataTable/columns/PaymentRequest/Partner'
import ClientPaymentRequestColumns from '@/components/GraphqlDataTable/columns/PaymentRequest/Client'
import RecruiterPlacementColumns from '@/components/GraphqlDataTable/columns/RecruiterPlacement'
import CompanyRecruiterColumns from '@/components/GraphqlDataTable/columns/CompanyRecruiter'
import SupplierClientColumns from '@/components/GraphqlDataTable/columns/SupplierClient'
import StaffingAgencyClientColumns from '@/components/GraphqlDataTable/columns/StaffingAgencyClient'
import CompanySupplierColumns from '@/components/GraphqlDataTable/columns/CompanySupplier'
import TrustedContactsColumns from '@/components/GraphqlDataTable/columns/TrustedContacts'
import ComplianceColumns from '@/components/GraphqlDataTable/columns/Compliance'
import OwnerColumns from '@/components/GraphqlDataTable/columns/Owner'
import CompanyTeamMemberColumns from '@/components/GraphqlDataTable/columns/CompanyTeamMember'

const columns: ColumnMaps = {
  ...HireColumns,
  ...JobColumns,
  ...CompanyColumns,
  ...JobShareColumns,
  ...BidColumns,
  ...PartnerEmploymentColumns,
  ...PartnerPaymentRequestColumns,
  ...ClientPaymentRequestColumns,
  ...RecruiterPlacementColumns,
  ...CompanyRecruiterColumns,
  ...SupplierClientColumns,
  ...StaffingAgencyClientColumns,
  ...CompanySupplierColumns,
  ...TrustedContactsColumns,
  ...ComplianceColumns,
  ...OwnerColumns,
  ...CompanyTeamMemberColumns,
}

export default columns
